module.exports = __webpack_public_path__ + "img/img_about.76e70247.png";